"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadStart = void 0;
const PreludeCard_1 = require("../prelude/PreludeCard");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Size_1 = require("../render/Size");
const Resources_1 = require("../../Resources");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const constants_1 = require("../../constants");
class HeadStart extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.HEAD_START,
            metadata: {
                cardNumber: 'X43',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.steel(2).nbsp().cards(1).colon().megacredits(2).asterix().br;
                    b.arrow(Size_1.Size.LARGE).arrow(Size_1.Size.LARGE);
                }),
                description: 'Gain 2 steel. Gain 2 M€ per project card you have in hand. Immediately take 2 actions.',
            },
        });
    }
    play(player) {
        player.addResource(Resources_1.Resources.STEEL, 2, { log: true });
        player.addResource(Resources_1.Resources.MEGACREDITS, 2 * player.cardsInHand.length, { log: true });
        player.game.defer(new DeferredAction_1.DeferredAction(player, () => {
            if (player.lastCardPlayed !== undefined && player.lastCardPlayed.name === CardName_1.CardName.DOUBLE_DOWN) {
                player.hasUsedHeadStart = false;
            }
            const eunice = player.playedCards.find((card) => card.name === CardName_1.CardName.EUNICE);
            if (eunice !== undefined && eunice.opgActionIsActive === true) {
                player.hasUsedHeadStart = false;
            }
            return undefined;
        }));
        player.game.defer(new DeferredAction_1.DeferredAction(player, () => {
            player.actionsTakenThisRound++;
            player.actionsTakenThisGame++;
            player.timer.rebateTime(constants_1.BONUS_SECONDS_PER_ACTION);
            player.takeAction();
            return undefined;
        }));
        return undefined;
    }
}
exports.HeadStart = HeadStart;
//# sourceMappingURL=HeadStart.js.map